import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Calendar, Star, User } from "lucide-react";

import { getFeedback } from "../Store/Actions/EnquiryActions";
import { Card, CardHeader, CardTitle } from "react-bootstrap";
import HomeNav from "../Components/HomeNav";
import Feedback from "./Feedback";

function ListFeedback() {
	const dispatch = useDispatch();

	const stateObject = useSelector((state) => state.enquiry);

	let errors = [];
	if (typeof stateObject.errors !== "undefined") {
		stateObject.errors.map((item) => (errors[item.param] = item.msg));
	}

	useEffect(() => {
		dispatch(getFeedback());
	}, []);

	return (
		<div id="webcrumbs">
			<div className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-pink-50">
				<HomeNav />

				<div className="space-y-2 flex flex-col item-center gap-4 flex-wrap max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
					<div className="text-right mt-4">
						<Feedback />
					</div>
					{stateObject.feedbackData?.map((feedback) => (
						<Card
							key={feedback.id}
							className="hover:!shadow-md !transition-shadow"
						>
							<CardHeader className="!bg-white !border-0 !border-none">
								<div className="flex flex-col sm:flex-row sm:items-start sm:justify-between !gap-1">
									<div className="flex-1">
										<CardTitle className="text-lg py-2 mb-2">
											{feedback.subject}
										</CardTitle>
										<Card.Subtitle className="text-sm text-gray-500 mt-3 mb-2">
											<div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
												<div className="flex items-center gap-1">
													<User className="w-4 h-4" />
													{feedback.name}
												</div>
												<div className="flex items-center gap-1">
													<Calendar className="w-4 h-4" />
													{new Date(
														feedback.createdAt
													).toLocaleDateString()}
												</div>
												{feedback.rating > 0 && (
													<div className="flex items-center gap-1">
														<Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
														{feedback.rating}/5
													</div>
												)}
											</div>
										</Card.Subtitle>
									</div>
								</div>
							</CardHeader>
							<Card.Body>
								<p className="text-gray-700 leading-relaxed">
									{feedback.message}
								</p>
								{feedback.email.toLowerCase() !==
									"anonymous" && (
									<div className="mt-4 pt-4 !border-t">
										<p className="text-sm text-gray-500">
											Contact: {feedback.email}
										</p>
									</div>
								)}
							</Card.Body>
						</Card>
					))}
				</div>
			</div>
		</div>
	);
}

export default ListFeedback;
